import { StyledMainDiv } from "Pages/MyBatchesAntd/MyBatchesAntd";
import React, { useContext, useEffect, useState } from "react";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import FacultiesBranchesHeader from "Pages/FacultiesAntd/Branches/FacultiesBranchesHeader";
import dayjs from "dayjs";
import FacultyHealthHeader from "Pages/Faculties/FacultyHealthHeader";
import { useGetApi } from "utilFunctions/CustomHooks/useGetAPI";
import { ToastContextDispatch, UserInfoContext } from "Context/CommonContext";
import { aggregatedorder } from "Pages/FacultiesAntd/Regions/FacultiesRegions";
import TableLayoutAntd from "utilFunctions/shared/AntdSharedComponents/TableLayoutAntd";
import FacultiesRegionsTable from "Pages/FacultiesAntd/Regions/FacultiesRegionsTable";
import { FacultyPerformanceContext } from "Context/FacultyPerformanceContext";
import {
  getMonthsBetweenDates,
  returnDateString,
} from "Pages/Faculties/FacultiesMain";
import { removeEmptyFields } from "utilFunctions/helperFunctions/HelperFunction";
import {
  BASE_URL,
  GET_FACULTY_PERFORMANCE_SEARCH,
} from "utilFunctions/Constants/urlConstants";
import { useLocation } from "react-router-dom";

const FacultiesBranch = () => {
  const { screen }: any = useWindowSize();
  const currentMonth = dayjs().startOf("month");
  const nextMonth = dayjs().endOf("month");
  const location = useLocation();
  const { state } = location;
  const userInfo = useContext<any>(UserInfoContext);
  const { facultyPerformance } = useContext(FacultyPerformanceContext);
  const ToastDispatch = useContext(ToastContextDispatch);
  const [dates, setDates] = useState<any>([currentMonth, nextMonth]);
  const [open, setOpen] = useState<boolean>(false);
  const [pagination, setPagination] = useState({
    pageSize: 10,
    total: 0,
    pageSizeOptions: ["10", "50", "100"],
    showSizeChanger: true,
    current: 1,
    sortField: "unmarkedLectureCount",
    sortOrder: "DESC",
  });
  const [filterState, setFilterState] = useState<any>({
    streamIds:
      state &&
      state.selectedStream &&
      state.selectedStream !== undefined &&
      state.selectedStream !== null
        ? state.selectedStream
        : userInfo?.userStreams && userInfo?.userStreams[0] != undefined
        ? userInfo?.userStreams[0]
        : null,
    subject: null,
    yearMonth: [dates[0]],
    chipFields: {},
  });
  const [cardAggregatedData, setCardAggregatedData] = useState<any>(null);
  const [BranchData, setBranchData] = useState<any>([]);
  const { makeRequest: GetFacultiesBranch, loading: tableloading } = useGetApi(
    (data) => {
      setOpen(false);
      if (
        data["data"] &&
        data["data"] &&
        data["data"]["facultyFeedbackResponse"]
      ) {
        setBranchData(data["data"]["facultyFeedbackResponse"] || []);
        const aggredatedDataList = data["data"]["facultyOverAllCardDetails"];
        setCardAggregatedData(aggredatedDataList);
        setPagination({
          ...pagination,
          total: data.totalCount,
        });
      } else {
        setCardAggregatedData(null);
        setBranchData([]);
      }
    },
    (error) => {
      setCardAggregatedData(null);
      setBranchData([]);
      if (error && error["message"]) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: error.message,
        });
      } else if (
        error &&
        error["response"] &&
        error["response"]["data"] &&
        error["response"]["data"]["code"] == "NF"
      ) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: "No record found",
        });
      }
    }
  );
  useEffect(() => {
    const branchId =
      location.pathname.split("/")[location.pathname.split("/").length - 1];
    const filterLength = Object.values(filterState).filter(
      (ele) => ele != null
    ).length;
    const offset = (pagination.current - 1) * pagination.pageSize;
    const limit = pagination.pageSize;
    if (Object.keys(facultyPerformance).length) {
      applyFilter(facultyPerformance);
    } else {
      if (userInfo?.userStreams && userInfo?.userStreams[0] != undefined) {
        const streamId = userInfo?.userStreams[0]?.value;
        const url =
          BASE_URL +
          GET_FACULTY_PERFORMANCE_SEARCH +
          "?sortBy=" +
          pagination.sortField +
          "&sortDir=" +
          pagination.sortOrder;
        if (filterLength) {
          applyFilter(filterState);
        } else {
          if (
            state &&
            state.selectedBatch &&
            state.selectedBatch !== undefined &&
            state.selectedBatch !== null
          ) {
            GetFacultiesBranch(
              `${url}&limit=${limit}&offset=${offset}&branch=${
                state.selectedBatch
              }&streamIds=${streamId}&yearMonth=${returnDateString(dates[0])}`
            );
          } else {
            GetFacultiesBranch(
              `${url}&limit=${limit}&offset=${offset}&branch=${branchId}&streamIds=${streamId}&yearMonth=${returnDateString(
                dates[0]
              )}`
            );
          }
        }
      }
    }
  }, [pagination.current, pagination.pageSize, pagination.sortOrder]);
  useEffect(() => {
    if (Object.keys(facultyPerformance).length) {
      const obj = {
        ...filterState,
        yearMonth: facultyPerformance?.yearMonth,
        subject: facultyPerformance?.subject,
        streamIds: facultyPerformance?.streamIds,
        chipFields: {
          yearMonth: facultyPerformance?.yearMonth,
          streamIds: facultyPerformance?.streamIds,
        },
      };
      if (facultyPerformance?.subject) {
        obj["chipFields"]["subject"] = facultyPerformance?.subject;
      }
      setFilterState(obj);
      setDates(facultyPerformance?.yearMonth);
    } else {
      setFilterState({
        streamIds:
          state &&
          state.selectedStream &&
          state.selectedStream !== undefined &&
          state.selectedStream !== null
            ? state.selectedStream
            : userInfo?.userStreams && userInfo?.userStreams[0] != undefined
            ? userInfo?.userStreams[0]
            : null,
        yearMonth: dates,
        chipFields: {
          streamIds:
            state &&
            state.selectedStream &&
            state.selectedStream !== undefined &&
            state.selectedStream !== null
              ? state.selectedStream
              : userInfo?.userStreams && userInfo?.userStreams[0] != undefined
              ? userInfo?.userStreams[0]
              : null,
          yearMonth: dates,
        },
      });
    }
  }, [userInfo?.userStreams, facultyPerformance]);

  const applyFilter = (filterStateObj: any) => {
    const limit = pagination.pageSize;
    const filterLength = Object.values(filterStateObj).filter(
      (ele) => ele != null
    ).length;
    if (filterLength) {
      const obj = {
        streamIds: filterStateObj.streamIds
          ? filterStateObj.streamIds.value
          : userInfo?.userStreams[0].value,
        // region: filterStateObj.region?.value,
        subject: filterStateObj.subject?.value,
        branch: filterStateObj.branch?.map((item: any) => item.id)?.toString(),
        yearMonth:
          filterStateObj.yearMonth && filterStateObj.yearMonth.length > 0
            ? getMonthsBetweenDates(
                filterStateObj.yearMonth[0],
                filterStateObj.yearMonth[1]
              )
            : returnDateString(dates[0]),
      };
      const filters2: any = [];
      const formValues: any = removeEmptyFields(obj);
      for (const key in formValues) {
        if (Object.prototype.hasOwnProperty.call(formValues, key)) {
          if (formValues[key] != null && formValues[key] != "") {
            filters2.push(
              encodeURIComponent(key) +
                "=" +
                encodeURIComponent(formValues[key])
            );
          }
        }
      }
      let url = BASE_URL + GET_FACULTY_PERFORMANCE_SEARCH;
      if (Array.isArray(filters2) && filters2.length > 0) {
        url = url + "?" + filters2.join("&");
      } else {
        url = url + "?";
      }
      url =
        url +
        "&sortBy=" +
        pagination.sortField +
        "&sortDir=" +
        pagination.sortOrder;
      const branchId =
        location.pathname.split("/")[location.pathname.split("/").length - 1];
      const offset = (pagination.current - 1) * pagination.pageSize;

      GetFacultiesBranch(
        `${url}&limit=${limit}&offset=${offset}&branch=${branchId}`
      );
    }
  };
  const processResponseForCardData = (data: any, aggregatedData: any): [] => {
    if (data !== null) {
      Object.keys(data).forEach((key) => {
        if (Object.hasOwnProperty.call(data, key)) {
          aggregatedData.push({
            label: key,
            value:
              key === "overAllRating" && data[key] === 0 ? "NA" : data[key],
          });
        }
      });
      const aggregatedDataModified = aggregatedData.filter(
        (item: any) => item.label !== "totalFacultiesCount"
      );
      aggregatedDataModified.push({
        label: "totalFacultiesCount",
        value: pagination.total,
      });
      aggregatedData = aggregatedDataModified;
    }
    const reorderedData: any = aggregatedorder.map((key: any) =>
      aggregatedData.find((item: any) => item.label === key)
    );

    return reorderedData;
  };
  const extraInformation = {
    selectedBatch:
      state &&
      state.selectedBatch &&
      state.selectedBatch !== undefined &&
      state.selectedBatch !== null
        ? state.selectedBatch
        : null,
    selectedRegion:
      state &&
      state.selectedRegion &&
      state.selectedRegion !== undefined &&
      state.selectedRegion !== null
        ? state.selectedRegion
        : null,
    selectedState:
      state &&
      state.selectedState &&
      state.selectedState !== undefined &&
      state.selectedState !== null
        ? state.selectedState
        : null,
    branchOrRegionId:
      state &&
      state.selectedRegion &&
      state.selectedRegion !== undefined &&
      state.selectedRegion !== null
        ? state.selectedRegion
        : null,
  };
  return (
    <StyledMainDiv screen={screen}>
      <FacultiesBranchesHeader
        setFilterState={setFilterState}
        filterState={filterState}
        open={open}
        setOpen={setOpen}
        dates={dates}
        setDates={setDates}
        applyFilter={applyFilter}
        pagination={pagination}
        extraInformation={extraInformation}
        mode="Faculty"
      ></FacultiesBranchesHeader>
      <FacultyHealthHeader
        mode="regionFaculties"
        aggregatedDataLoading={tableloading}
        aggregatedData={processResponseForCardData(cardAggregatedData, [])}
      />
      <TableLayoutAntd isLoader={false}>
        <FacultiesRegionsTable
          data={BranchData}
          pagination={pagination}
          setPagination={setPagination}
          mode="Faculty"
          extraInformation={extraInformation}
        ></FacultiesRegionsTable>
      </TableLayoutAntd>
    </StyledMainDiv>
  );
};

export default FacultiesBranch;
